import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { TURNS_ON_OPTIONS } from '@/pages/Onboarding/options/TurnsOn/TURNS_ON_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

export const ScreenTurnsOn: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'TurnsOn',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const turnsOn = form.watch('turns_on');

  const handleChange = (option: OnbOptionType<LayoutDataType['turns_on']>) => {
    userService.createOrUpdate({
      onboarding_data: {
        turnsOn: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <OnboardingPage>
      <OnboardingNavigation />

      <IonContent>
        <OwnAiTitle>Now, what turns you on?</OwnAiTitle>
        <OnboardingOptionsList>
          {TURNS_ON_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={turnsOn === option.id}
              control={form.control}
              option={option}
              name="turns_on"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`turns-on-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </OnboardingPage>
  );
};
